module.exports = __webpack_public_path__ + "media/images/logo-md-4fd050c7.png";